export default __webpack_public_path__ + "static/media/blackArgo.e306c2c0.svg";